import { useQuery } from '@tanstack/react-query'
import { webApi } from '@/services/webApi'

/** Real listing counts per header menu link for the selected city. */
export function useMenuCounts(city?: string) {
  return useQuery({
    queryKey: ['web', 'menu-counts', city ?? 'all'],
    queryFn: () => webApi.menuCounts(city ? { city } : undefined),
    staleTime: 5 * 60_000,
    retry: 1,
  })
}
